export default __webpack_public_path__ + "static/media/Group 3201.433bbe4a.svg";